import { useUserListShortQuery } from '@common/cache';
import { useState } from 'react';

export const useDeactivateUserModal = (userId: string) => {
  const { data = [] } = useUserListShortQuery({});

  const [selectedUser, setSelectedUser] = useState<{
    label: string;
    value: string;
  } | null>({ label: 'Unassigned (Available to team)', value: '' });

  const handleSelectUser = (user: { label: string; value: string } | null) => {
    setSelectedUser(user);
  };

  return {
    userOptions: [
      { label: 'Unassigned (Available to team)', value: '' },
      ...data
        .filter(item => item.id !== userId)
        .map(item => ({ label: item.name, value: item.id })),
    ],
    selectedUser,
    handleSelectUser,
  };
};
